module.exports = __webpack_public_path__ + "static/media/individual.6bec09d4.svg";